import Link from 'next/link';
import { useRouter } from 'next/router';
import type { ComponentProps, FC } from 'react';

import { useProfile } from '@/hooks/useProfile';

import AuthDialog from './AuthDialog';
import { AuthPageEnum } from './AuthEnum';

const AuthLinkWithDialog: FC<ComponentProps<typeof Link>> = ({
  children,
  ...props
}) => {
  const { data: profileData } = useProfile();
  const router = useRouter();

  if (profileData) return <Link {...props}>{children}</Link>;

  const handleSuccess = () => {
    router.push(props.href);
  };

  return (
    <AuthDialog
      defaultPage={AuthPageEnum.LOGIN_PROVIDERS}
      dialogTriggerProps={{ asChild: true }}
      onSuccess={handleSuccess}
    >
      <button type="button" className={props.className}>
        {children}
      </button>
    </AuthDialog>
  );
};

export default AuthLinkWithDialog;
